import { encodeBase64 } from "utils";

export const FeedbackMediaSerializer = (feedback, noMedia = false) => {
  let _hasMedia = false;

  const promisedFeedbackOptions = feedback.feedback_options.map(
    feedbackOption => {
      const rawFiles = feedbackOption.files || [];
      const promisedFiles = noMedia
        ? []
        : rawFiles
            .filter(file => file.uri)
            .map(file => {
              _hasMedia = true;
              return encodeBase64(file.uri).then(content => {
                return { content, type: file.type };
              });
            });
      return Promise.all(promisedFiles).then(files => {
        // backend accepts attachments key, rename `files` to `attachments`
        const { files: _, ...rest } = feedbackOption;
        return { ...rest, attachments: files };
      });
    },
  );

  return Promise.all(promisedFeedbackOptions).then(feedback_options => {
    return {
      ...feedback,
      _hasMedia,
      feedback_options,
    };
  });
};
